module.exports = __webpack_public_path__ + "static/media/17.5145db24.jpg";